import * as React from 'react';
import { Mui, MuiIcons } from '@leap4/frontend';
import {useHistory} from "react-router-dom";
import {
    DragDropContext,
    Droppable,
    Draggable,
    OnDragEndResponder
} from 'react-beautiful-dnd';

const { Autocomplete, TextField, Stack, Chip } = Mui;
type StackProps = Mui.StackProps;
type TextFieldProps = Mui.TextFieldProps;
const { Link } = MuiIcons;

export interface IFormChipsProps {
    optionsList: any[]
    valueKey?: string
    labelKey?: string
    onUpdateItems: (items: any) => void
    inputName: string
    enableCreate: boolean
    chips?: string[],
    link?: (keyValue: string) => string
    pureCreate: boolean
    stackProps?: StackProps,
    textFieldProps?: TextFieldProps
    filterTags?: (item) => boolean,
    disabled?: boolean,
    disableCloseOnSelect?: boolean,
    controlledValue?: any,
    onDragEndFn?: (dragEvent: any) => void,
    placeholder?: string
    chipStylingFn?: (chip: any) => object;

}

//CONTROLLED MEANS YOU NEED TO PROVIDE AN "INPUT" (controlledInput) FIELD TO CONTROL THE STATE OF THE CHIPS OUTSIDE THE COMPONENT
//AND PROVIDE PURE KEY VALUE OBJECTS

const FormChipsControlled = function FormChips(props: IFormChipsProps) {
    const filterTags = props.filterTags || function (item) {
        return true
    }
    const history = useHistory();

    const handleDefaultChips = () => {
        let arr = [];
        if (props.enableCreate) {
            return props.chips
        } else {
            const optionsListValueKeys = props.optionsList.map(option => option[props.valueKey]);
            props.chips.forEach(chip => optionsListValueKeys.includes(chip) ?
                arr.push(props.optionsList[optionsListValueKeys.indexOf(chip)]) : arr.push({
                    [props.valueKey]: chip,
                    [props.labelKey]: chip
                }))
        }
        return arr;
    };

    const handleOnChange = (e, value) => {
        const {valueKey, labelKey, enableCreate} = props
        if (valueKey && labelKey) {
            props.onUpdateItems(enableCreate ? value : value.map(item => item[valueKey] !== undefined ? item[valueKey] : item))
        } else {
            props.onUpdateItems(value)
        }
    };

    const handleDeleteChip = (indexOfItemToDelete: number, values: string[]) => {
        const {valueKey, enableCreate} = props
        if (valueKey) {
            values.splice(indexOfItemToDelete, 1)
            props.onUpdateItems(enableCreate ? values : values.map(item => item[valueKey]))
        } else {
            values.splice(indexOfItemToDelete, 1)
            props.onUpdateItems(values)
        }
    };

    const onDragEnd = (e) => {
        props.onDragEndFn(e)
    }


    return (
        <>
            {(props.optionsList?.length || props.pureCreate) ?
                <Stack spacing={3} style={{width: '500px', marginTop: '8px'}} {...props.stackProps} >
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId={"check"} key={'place'} direction={'horizontal'}>
                            {
                                provided =>
                                    <div ref={provided.innerRef} {...provided.droppableProps} style={{overflow: 'auto'}}>
                                        <Autocomplete
                                            style={{paddingTop: '10px'}}
                                            value={props.controlledValue || []}
                                            multiple
                                            disableCloseOnSelect={props.disableCloseOnSelect}
                                            id="multiple-autocomplete-chips"
                                            isOptionEqualToValue={(option, value) => {
                                                return option.value === value.value

                                            }}
                                            options={props.optionsList}
                                            getOptionLabel={(option) => props.enableCreate ? option : option[props.labelKey]}
                                            onChange={handleOnChange}
                                            filterSelectedOptions
                                            // getOptionDisabled={(option) => option === ""}
                                            // defaultValue={handleDefaultChips()}
                                            freeSolo={true}
                                            disabled={props.disabled}
                                            renderTags={(values) => values.filter(filterTags).map((option, index) =>
                                            {
                                                return (
                                                    <Draggable draggableId={option[props.valueKey]}
                                                               index={index}
                                                               key={option[props.valueKey]}>
                                                        {
                                                            (provided, snapshot) => (
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}
                                                                >
                                                                    <Chip
                                                                        key={index}
                                                                        variant="outlined"
                                                                        label={props.enableCreate ? option : option[props.labelKey]}
                                                                        sx={{
                                                                            marginRight: 0.4,
                                                                            ...props.chipStylingFn?.(option)
                                                                        }}
                                                                        onDelete={() => handleDeleteChip(index, values)}
                                                                        icon={props.link &&
                                                                            <Link
                                                                                onClick={() => history.push(props.link(option[props.valueKey]))}/>}
                                                                        clickable
                                                                    />
                                                                    {provided.placeholder}
                                                                </div>
                                                            )
                                                        }
                                                    </Draggable>

                                                )
                                            })

                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    placeholder={props.placeholder|| 'Add Item'}
                                                    {...params}

                                                    label={props.inputName}
                                                    name={props.inputName}
                                                    {...props.textFieldProps}
                                                />
                                            )}
                                        />
                                    </div>
                            }
                        </Droppable>
                    </DragDropContext>

                </Stack> : <TextField sx={{width: 500}} label={props.inputName} name={props.inputName}
                                      disabled {...props.textFieldProps} error/>}
        </>

    );
};

export {FormChipsControlled}
